import { Button, ButtonVariant } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
const ZoomTool = (): JSX.Element => { 
    const zoom: number      = useLandingStore((state: ILandingStore) => state.zoom)
    const setDefaultZoom    = useLandingStore((state: ILandingStore) => state.setDefaultZoom) 
    
    return <Button variant={ zoom !== 100 ? ButtonVariant.SOLID : ButtonVariant.MINIMAL } onClick={ setDefaultZoom } >
        <div className={`d-flex flex-column align-items-center `}>
            <img src="/assets/img/landing/zoom.svg" alt="" height={15} className="panel-icon" />
            <div className="micro letter-spacing-1">{ __( `${ zoom }%` ) }</div>
        </div>
    </Button>
}
export default ZoomTool